import { ContactCardComponent } from '../contact-card/contact-card.component';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  getCustomerServicePhone,
  getCustomerServiceTel,
  HOMEOWNERS_INSURANCE,
  HOMEOWNER_SUPPORT_URL,
  HUD_COUNSELING,
  INSURANCE_CLAIMS,
  LOANDEPOT_MAILING_ADDRESS,
  NY_DFS_CONSUMER_DISPLAY,
  NY_DFS_CONSUMER_TEL,
  PAYOFF_STATEMENTS,
  PROPERTY_TAXES_ESCROW,
  PROPERTY_TAXES_NON_ESCROW,
  TEXAS_CONSUMER_HOTLINE_DISPLAY,
  TEXAS_CONSUMER_HOTLINE_TEL,
  WA_HOMEOWNERSHIP_HOTLINE,
} from '@ld.consumer-portal/constants';
import { REGULATORY_URLS } from '@ld.consumer-portal/constants';
import { LoanSelectionService, PlatformService } from '@ld.consumer-portal/utils';

@Component({
  selector: 'ld-contact-us-page',
  imports: [ ContactCardComponent,MatIconModule, RouterLink, TranslocoPipe],
  templateUrl: './contact-us-page.component.html',
  styleUrl: './contact-us-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly platformService = inject(PlatformService);
  private readonly loanSelectionService = inject(LoanSelectionService);

  protected readonly isNativeMobile = this.platformService.isNativeMobile;

  protected readonly isHeloc = this.loanSelectionService.isHeloc;

  protected readonly faqsLink = computed(() => {
    const accountId = this.route.snapshot.paramMap.get('accountId');
    return accountId ? `/help/${accountId}/faqs` : '/dashboard';
  });

  protected readonly customerServicePhone = computed(() => getCustomerServicePhone(this.loanSelectionService.customerServiceLoanCategory()));

  protected readonly customerServiceTel = computed(() => getCustomerServiceTel(this.loanSelectionService.customerServiceLoanCategory()));

  protected readonly propertyTaxesEscrow = PROPERTY_TAXES_ESCROW;

  protected readonly propertyTaxesNonEscrow = PROPERTY_TAXES_NON_ESCROW;

  protected readonly homeownersInsurance = HOMEOWNERS_INSURANCE;

  protected readonly insuranceClaims = INSURANCE_CLAIMS;

  protected readonly writtenCorrespondenceAddress = LOANDEPOT_MAILING_ADDRESS;

  protected readonly payoffStatements = PAYOFF_STATEMENTS;

  protected readonly homeownerSupportUrl = HOMEOWNER_SUPPORT_URL;
  protected readonly hudCounseling = HUD_COUNSELING;
  protected readonly waHotline = WA_HOMEOWNERSHIP_HOTLINE;

  protected readonly texasHotlinePhone = TEXAS_CONSUMER_HOTLINE_DISPLAY;
  protected readonly texasHotlineTel = TEXAS_CONSUMER_HOTLINE_TEL;
  protected readonly nyDfsPhone = NY_DFS_CONSUMER_DISPLAY;
  protected readonly nyDfsTel = NY_DFS_CONSUMER_TEL;
  protected readonly nyDfsUrl = REGULATORY_URLS.NY_DFS;
}
